import React from 'react';
import { Card, CardContent } from '../components/ui/card';
import { Button } from '../components/ui/button';
import { Users, UserPlus, Settings } from 'lucide-react';

export default function Team() {
  return (
    <div className="space-y-6">
      <div className="flex items-center justify-between">
        <div>
          <h1 className="text-2xl font-bold text-stone-900">Team Management</h1>
          <p className="text-stone-600 mt-1">
            View and manage team members and permissions
          </p>
        </div>
        <div className="flex items-center space-x-3">
          <Button variant="outline">
            <Settings className="w-4 h-4 mr-2" />
            Settings
          </Button>
          <Button>
            <UserPlus className="w-4 h-4 mr-2" />
            Add Member
          </Button>
        </div>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
        <Card>
          <CardContent className="p-6 text-center">
            <div className="w-12 h-12 bg-blue-100 rounded-lg flex items-center justify-center mx-auto mb-4">
              <Users className="w-6 h-6 text-blue-600" />
            </div>
            <h3 className="text-lg font-semibold text-stone-900 mb-2">
              Total Members
            </h3>
            <p className="text-3xl font-bold text-blue-600">--</p>
          </CardContent>
        </Card>

        <Card>
          <CardContent className="p-6 text-center">
            <div className="w-12 h-12 bg-green-100 rounded-lg flex items-center justify-center mx-auto mb-4">
              <Users className="w-6 h-6 text-green-600" />
            </div>
            <h3 className="text-lg font-semibold text-stone-900 mb-2">
              Active Users
            </h3>
            <p className="text-3xl font-bold text-green-600">--</p>
          </CardContent>
        </Card>

        <Card>
          <CardContent className="p-6 text-center">
            <div className="w-12 h-12 bg-yellow-100 rounded-lg flex items-center justify-center mx-auto mb-4">
              <Settings className="w-6 h-6 text-yellow-600" />
            </div>
            <h3 className="text-lg font-semibold text-stone-900 mb-2">Roles</h3>
            <p className="text-3xl font-bold text-yellow-600">3</p>
          </CardContent>
        </Card>
      </div>

      <Card>
        <CardContent className="p-6">
          <div className="text-center py-12">
            <Users className="mx-auto h-12 w-12 text-stone-300 mb-4" />
            <h3 className="text-lg font-medium text-stone-900 mb-2">
              Team Management Coming Soon
            </h3>
            <p className="text-stone-600 max-w-md mx-auto">
              The team management interface is being developed. You'll be able
              to view team members, manage roles and permissions, and track user
              activity.
            </p>
          </div>
        </CardContent>
      </Card>
    </div>
  );
}
